import debounce from 'lodash.debounce'
import { Message } from '@weblite/ts-action/message'
import { notif } from '$setup/audios'
import { isMessageFromClientUser } from '$logic/message'
import { windowFocusView } from '$comp/main/root.reducer'
import { getOpenedRoomId } from '$logic/opened-room'
import { getRoom, storageByRoomType } from '$logic/room'
import { notifAudioStorage } from '$logic/notif-audio/storage'
import { nothing } from '$func/utils'

const shouldNotifyMessage = (message: Message) =>
  !isMessageFromClientUser(message) &&
  (!windowFocusView() || message.roomId !== getOpenedRoomId())

const shouldNotifyRoom = async (roomId: string) => {
  const room = await getRoom(roomId)
  if (room && room.type !== 'PRIVATE_SPACE') {
    const { muted } = await storageByRoomType(room.type).get(roomId)
    if (!muted) return true
  }
  return false
}

const debouncePlayNotif = debounce(() => notif.play()?.catch(nothing), 450)

export async function handleNotifAudio(messages: Message[]) {
  const { muted } = notifAudioStorage.get() || { muted: false }
  if (muted) return
  const messagesToNotify = await Promise.all(
    messages.map(
      msg => shouldNotifyMessage(msg) && shouldNotifyRoom(msg.roomId),
    ),
  )

  if (messagesToNotify.find(notify => notify)) debouncePlayNotif()
}

export async function setNotifAudioMuted(muted: boolean) {
  notifAudioStorage.set({ muted })
}
